import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { sendFrontAction } from '../../services/api';
import CarCard from '../../components/CarCard/CarCard';
import './Catalog.css';

const Catalog = ({ type }) => {
    const [cars, setCars] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState({ body_type: '', sort: '' });
    const isUsed = type === 'used';

    const loadCars = async () => {
        setLoading(true);
        try {
            const data = await sendFrontAction('catalog', {
                type: type,
                body_type: filters.body_type
            });
            setCars(data);
        } catch (error) {
            console.error("Ошибка загрузки каталога автомобилей:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadCars();
    }, [type, filters.body_type]);

    const handleFilterChange = (e) => {
        setFilters({ ...filters, body_type: e.target.value });
    };

    if (loading) return <div className="catalog-loader">Загрузка моделей BMW....</div>;

    return (
        <div className="catalog-container">
            <Link to="/" className="catalog-back-link">‹ Назад на главное меню</Link>

            <h1 className="catalog-main-title">
                {isUsed ? 'BMW с пробегом' : 'Новые BMW в наличии'}
            </h1>

            <div className="catalog-filter-grid">
                <div className="catalog-filter-box">
                    <select className="catalog-select" onChange={handleFilterChange} value={filters.body_type}>
                        <option value="">Все типы кузова</option>
                        <option value="Sedan">Седан</option>
                        <option value="SUV">Внедорожник</option>
                        <option value="Coupe">Купе</option>
                    </select>
                </div>
                {["Цена", "Двигатель", "Цвет"].map(cat => (
                    <div key={cat} className="catalog-filter-box">
                        <select className="catalog-select"><option>{cat}</option></select>
                    </div>
                ))}
            </div>

            <div className="catalog-active-filter-row">
                <button className="catalog-reset-btn" onClick={() => setFilters({ body_type: '', sort: '' })}>
                    Сбросить фильтры
                </button>
            </div>

            <div className="catalog-grid">
                {cars && cars.length > 0 ? (
                    cars.map(car => (
                        <CarCard
                            key={car.id}
                            car={{
                                ...car,
                                displayPrice: isUsed ? car.price : car.price_base,
                                year: isUsed ? car.year_of_issue : car.year
                            }}
                            isUsed={isUsed}
                        />
                    ))
                ) : (
                    <p className="catalog-no-data">В данный момент нет доступных авто.</p>
                )}
            </div>
        </div>
    );
};

export default Catalog;